import _ from "underscore";
import moment from "moment";

import { CELL_TYPES } from "../index";

export const filterType = {
  EUQAL: "eq",
  MORE_THAN: "more",
  LESS_THAN: "less",
  CAONTAINS: "contain",
};

export const filter_display = {
  [filterType.EUQAL]: "=",
  [filterType.LESS_THAN]: "<",
  [filterType.MORE_THAN]: ">",
  [filterType.CAONTAINS]: "abc",
};

export function filterTable(items, tableInfo) {
  let filters = Object.keys(tableInfo.currentFilter);

  for (let i = 0; i < filters.length; i++) {
    let filterData = tableInfo.currentFilter[filters[i]];

    if (
      filterData.filter === "" ||
      filterData.filter === null ||
      filterData.filter === undefined ||
      (_.isObject(filterData.filter) && !Object.keys(filterData.filter).length)
    )
      continue;

    let getValueFunc;
    let keys = filters[i].split(".");

    if (keys.length === 2) getValueFunc = getValue2;
    else if (keys.length === 1) {
      getValueFunc = getValue;
      keys.push("");
    }

    if (CELL_TYPES.date == filterData.cellType) {
      items = _.filter(items, (item) =>
        filterDates(getValueFunc(item, keys[0], keys[1]), filterData.filter),
      );
      continue;
    }

    if (CELL_TYPES.enum == filterData.cellType) {
      items = _.filter(items, (item) =>
        filterEnum(getValueFunc(item, keys[0], keys[1]), filterData.filter),
      );
      continue;
    }
    if (CELL_TYPES.listOfEnum == filterData.cellType) {
      items = _.filter(items, (item) =>
        filterListEnum(getValueFunc(item, keys[0], keys[1]), filterData.filter),
      );
      continue;
    }

    if (filterData.type === filterType.EUQAL) {
      items = _.filter(
        items,
        (item) => getValueFunc(item, keys[0], keys[1]) == filterData.filter,
      );
    } else if (filterData.type === filterType.MORE_THAN) {
      items = _.filter(
        items,
        (item) => getValueFunc(item, keys[0], keys[1]) > filterData.filter,
      );
    } else if (filterData.type === filterType.LESS_THAN) {
      items = _.filter(
        items,
        (item) => getValueFunc(item, keys[0], keys[1]) < filterData.filter,
      );
    } else if (filterData.type === filterType.CAONTAINS) {
      items = _.filter(items, (item) =>
        String(getValueFunc(item, keys[0], keys[1]))
          .toLowerCase()
          .includes(filterData.filter.toLowerCase()),
      );
    }
  }
  return items;
}

export default filterTable;

function filterDates(value, filter) {
  if (filter.fromDate && !filter.toDate)
    return moment(value).isAfter(moment(filter.fromDate));
  if (!filter.fromDate && filter.toDate)
    return moment(value).isBefore(moment(filter.toDate));
  if (filter.fromDate && filter.toDate)
    return moment(value).isBetween(
      moment(filter.fromDate),
      moment(filter.toDate),
    );
  return true;
}

function filterEnum(value, filter) {
  return filter[value];
}
function filterListEnum(value, filter) {
  return value.some((e) => filter[e]);
}

function getValue(object, key1) {
  return object[key1];
}

function getValue2(object, key1, key2) {
  return object[key1][key2];
}
